/**
 * Handles checkbox groups with exclusive option(s) (e.g., "Other/ Unsure").
 * When an exclusive checkbox is selected, all other checkboxes in the group are unchecked.
 * When any other checkbox is selected, all exclusive checkboxes are unchecked.
 *
 * Uses event delegation to attach a single change listener per checkbox group.
 *
 * @param {string} exclusiveOptionAttribute - Attribute used to identify the exclusive checkbox (defaults to 'data-exclusive-option').
 * @returns {void}
 */
export default function handleCheckboxExclusiveOption(exclusiveOptionAttribute = 'data-exclusive-option') {
	document.querySelectorAll('.checkbox--group').forEach(group => {
		const checkboxes = [...group.querySelectorAll('input[type="checkbox"]')];
		const exclusiveOptions = checkboxes.filter(cb => cb.hasAttribute(exclusiveOptionAttribute));

		if (!exclusiveOptions.length) {
			return;
		}

		group.addEventListener('change', (e) => {
			const cb = e.target;

			if (!checkboxes.includes(cb)) {
				return;
			}

			if (exclusiveOptions.includes(cb) && cb.checked) {
				checkboxes.forEach(c => {
					if (c !== cb) {
						c.checked = false;
					}
				});
				return;
			}

			if (!exclusiveOptions.includes(cb) && cb.checked) {
				exclusiveOptions.forEach(c => {
					c.checked = false;
				});
			}
		});
	});
}
